export default "__VITE_ASSET__8_yW14Qr__"